import {hueFor} from '../daypart';

const firstLetter = (word: string): string => Array.from(word)[0]?.toUpperCase() ?? '';

// Up to two initials (first and last name), or a mark when the name is blank.
export const initialsOf = (name: string): string => {
    const words = name.trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return '?';
    const first = firstLetter(words[0]);
    return words.length === 1 ? first : first + firstLetter(words[words.length - 1]);
};

export const avatarFallback = (name: string): {text: string; hue: number} => ({
    text: initialsOf(name),
    hue: hueFor(name),
});
